export const COUNTRY_HIERARCHY_INPUT_KEY = 'country-hierarchy';
export const COUNTRY_HIERARCHY_MULTI_SELECT_KEY = 'country-hierarchy-multi-select';

export const countryKeys = {
  all: ['countries'] as const,
  lists: () => [...countryKeys.all, 'list'] as const,
  list: (page: number, pageSize: number, isActive?: boolean, search?: string, level?: string) =>
    [...countryKeys.lists(), page, pageSize, isActive, search, level] as const,
  defaultList: () => [...countryKeys.lists(), 1, 10, undefined, undefined, undefined] as const,
  details: () => [...countryKeys.all, 'detail'] as const,
  detail: (id: string) => [...countryKeys.details(), id] as const,
  territories: () => [...countryKeys.all, 'territories'] as const,
  territoryList: (level?: string) => [...countryKeys.territories(), level] as const,
  hierarchy: () => [...countryKeys.all, 'hierarchy'] as const,
  hierarchyDetail: (id: string) => [...countryKeys.hierarchy(), id] as const,
};
